import moment from 'moment';

export function makeDob (age) {
  const date = moment().subtract(age, 'years').subtract(1, 'days');
  const year = date.year();
  const month = date.month() + 1;
  const day = date.date();
  const monthStr = month > 9 ? month : `0${month}`;
  const dayStr = day > 9 ? day : `0${day}`;

  return `${year}-${monthStr}-${dayStr}`;
}

export function getAge (dob) {
  const birthday = moment(dob);
  const today = moment();
  return Math.abs(birthday.diff(today, 'years'));
}

export function getChatDateFormat (date) {
  return moment(date + '+0000').calendar(null, {
    sameDay: 'h:mm A',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastDay: '[Yesterday]',
    lastWeek: 'dddd',
    sameElse: 'MM/DD/YY'
  });
}

export function getMaxDate (date1, date2) {
  if (!date1 || date1 === null) {return date2;}
  if (!date2 || date2 === null) {return date1;}

  return date1 > date2 ? date1 : date2;
}

export function getMonthDayYear (date) {
  return date ? moment.utc(date).format('MMM DD, YYYY ') : null;
}

export function getLocalUnixDateTime () {
  return moment().unix();
}

export function isHappyHourActive (next, last, duration) {
  let timestamp = getLocalUnixDateTime();
  let active = false;
  if (timestamp >= last && timestamp <= last + duration) {
    active = true;
  }
  if (timestamp >= next && timestamp <= next + duration) {
    active = true;
  }
  return active;
}
